import { get } from '@/utils/http';

export const getHomePageSettings = () => {
    return get('homepage?populate=video_mobile, video_desktop, contact_image');
}